import Home from "../../../assets/navigations/imageSide2.png";
import DisableLeftHome from "../../../assets/navigations/DisableHome.png";
import DisableRigthHome from "../../../assets/navigations/DisableRigthHome.png";
import HomeDark from "../../../assets/navigations/dark.png"; // Dark theme image path
import HomeSign from '../../../assets/navigations/imagesideHome.png';
import plusMinusBg from '../../../assets/navigations/imageSide1.png';
import PlusSign from '../../../assets/navigations/imagePlus.png';
import DisablePlus from '../../../assets/navigations/DisableMinusSvg.svg'
import DisableMinus from '../../../assets/navigations/DisablePlusSvg.svg'
import DisablePreviousBtn from '../../../assets/navigations/DisablePreviousbutton.png'
import DisableNextBtn from '../../../assets/navigations/DisableNextbutton.png'
import LigthLocationNavigation from '../../../assets/sidebarBookmark/Light_LocateMe.svg'
import DarkLocationNavigation from '../../../assets/sidebarBookmark/Dark_LocateMe.svg'

import MinusSign from '../../../assets/navigations/imageMinus.png';
import plusMinusBgDark from '../../../assets/navigations/darkrectangle.png'; // Dark theme background
import Hand from '../../../assets/navigations/imagesideHand.png';
import LeftArrow from '../../../assets/navigations/imagesideLeftArrow.png';
import RightArrow from '../../../assets/navigations/imagesideRigthArrow.png'; // Fixed typo in variable name
import DashSign from '../../../assets/navigations/image.png';
import { useTheme } from "../ThemeContext/ThemeContext";
import { useAuth } from "../../../Providers/AuthProvider/AuthProvider";
import { useEffect, useState, useRef } from "react";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils.js";
import BookmarkWhite from '../../../assets/sidebarBookmark/bookmark.svg'
import LocationupdatedLogo from '../../../assets/Header/GeneralInformation/updatedLocation.svg';
import LocationupdatedColorLogo from '../../../assets/Header/GeneralInformation/updatedLocation-color.svg';
import StackLogo from '../../../assets/Header/Layerlist/Stack.svg';
import StackLogoColor from '../../../assets/Header/Layerlist/StackColor.svg';
import { ZodSymbol } from "zod";

import "react-tooltip/dist/react-tooltip.css";
import { Tooltip as ReactTooltip } from "react-tooltip";
import './sidebar.css'
import Locate from "@arcgis/core/widgets/Locate.js";
import Graphic from "@arcgis/core/Graphic";


export default function Sidebar({handleBasemapMenuItemClick}) {
  const { isDarkMode, isLangArab ,isGeneralInfo,setIsGeneralInfo,isStackInfo,setIsStockInfo} = useTheme(); // Access the theme from context
  const { contextMapView, initialExtent,isEditPOI, extentHistory, setExtentHistory, currentExtentIndex, setCurrentExtentIndex } = useAuth();
  const [panmode, setPanMode] = useState(true);
  const [showInfo, setShowInfo] = useState(false);
  // Mutable refs for extent history
  const _prevExtent = useRef(false);
  const _preExtent = useRef(null);
  const _currentExtent = useRef(null);
  const _extentHistory = useRef([]);
  const _extentHistoryIndx = useRef(0);
  const _nextExtent = useRef(false);
  const zoomPrevBtn = useRef(null);
  const zoomNextBtn = useRef(null);
  const [IsMaxZoom,setIsMaxZoom] = useState(true)
  const [IsMinZoom,setIsMinZoom] = useState(true)
  const [canGoBack, setCanGoBack] = useState(false);
  const [canGoForward, setCanGoForward] = useState(false);
   // Add new state for zoom tracking
   const [currentZoom, setCurrentZoom] = useState(0);
   const [maxZoom, setMaxZoom] = useState(null);
   const [minZoom, setMinZoom] = useState(null);

  // useEffect(() => {
  //   if (contextMapView) {
  //     // Handle extent change
  //     reactiveUtils.when(
  //       () => contextMapView.stationary,
  //       () => {
  //         extentChangeHandler(contextMapView.extent);
  //       }
  //     );
  //   }
  // }, [contextMapView]);

  useEffect(() => {
     if (contextMapView) {
    //   const locateWidget = new Locate({
    //     view: contextMapView, // Attach the Locate widget to the view
    //     container: "findLocation"
    //     // graphic: new Graphic({
    //     //   symbol: {
    //     //     type: "simple-marker", // Type of marker
    //     //     style: "circle", // Marker style
    //     //     color: "blue", // Marker color
    //     //     size: "12px", // Marker size
    //     //     outline: { // Marker outline
    //     //       color: "white",
    //     //       width: 2
    //     //     }
    //     //   }
    //     //})
    //   });
    //     locateWidget.locate().then(() => {
    //     console.log("User location found!");
    //   }).catch((error) => {
    //     console.error("Error locating the user:", error);
    //   });
       // Add the Locate widget to the view
    //contextMapView.ui.add(locateWidget, "top-left");
      // Initialize zoom constraints
      // const maxZoomValue = contextMapView.constraints.maxZoom;
      // const minZoomValue = contextMapView.constraints.minZoom;
      const maxZoomValue = 23
      const minZoomValue = 0
      setMaxZoom(maxZoomValue);
      setMinZoom(minZoomValue);
      setCurrentZoom(contextMapView.zoom);

  
      // Watch for zoom changes
      const zoomWatch = reactiveUtils.watch(
        () => contextMapView.zoom,
        (newZoom) => {
          setCurrentZoom(newZoom);

          if(newZoom < maxZoomValue){
            setIsMaxZoom(true)
          }else{
            setIsMaxZoom(false)
          }

          if(newZoom > minZoomValue){
            setIsMinZoom(true)
          }else{
            setIsMinZoom(false)
          }
          console.log('Current Zoom:', newZoom);
          console.log('Max Zoom:', maxZoomValue);
          console.log('Min Zoom:', minZoomValue);
        }
      );
  
      // Watch for extent changes
      const extentWatch = reactiveUtils.when(
        () => contextMapView.stationary,
        () => {
          extentChangeHandler(contextMapView.extent);
        }
      );
  
      return () => {
        if (zoomWatch) zoomWatch.remove();
        if (extentWatch) extentWatch.remove();
      };
    }
  }, [contextMapView]);


  

 
  // Handle extent change and history
  const extentChangeHandler = (evt) => {
    console.log('extent changed', evt);
    if (_prevExtent.current || _nextExtent.current) {
      _currentExtent.current = evt;
    } else {
      _preExtent.current = _currentExtent.current;
      _currentExtent.current = evt;
      _extentHistory.current.push({
        preExtent: _preExtent.current,
        currentExtent: _currentExtent.current
      });
      _extentHistoryIndx.current = _extentHistory.current.length - 1;
    }
    _prevExtent.current = _nextExtent.current = false;
    extentHistoryChange();
  };

  // Update button states
  // const extentHistoryChange = () => {
  //   if (_extentHistory.current.length === 0 || _extentHistoryIndx.current === 0) {
  //     if (zoomPrevBtn.current) zoomPrevBtn.current.classList.add("disabled");
  //   } else {
  //     if (zoomPrevBtn.current) zoomPrevBtn.current.classList.remove("disabled");
  //   }
  //   if (_extentHistory.current.length === 0 || _extentHistoryIndx.current === _extentHistory.current.length - 1) {
  //     if (zoomNextBtn.current) zoomNextBtn.current.classList.add("disabled");
  //   } else {
  //     if (zoomNextBtn.current) zoomNextBtn.current.classList.remove("disabled");
  //   }
  // };

  const extentHistoryChange = () => {
    const canNavigateBack = _extentHistory.current.length > 0 && _extentHistoryIndx.current > 0;
    const canNavigateForward = _extentHistory.current.length > 0 && 
                              _extentHistoryIndx.current < _extentHistory.current.length - 1;

    setCanGoBack(canNavigateBack);
    setCanGoForward(canNavigateForward);

    if (!canNavigateBack) {
      if (zoomPrevBtn.current) zoomPrevBtn.current.classList.add("disabled");
    } else {
      if (zoomPrevBtn.current) zoomPrevBtn.current.classList.remove("disabled");
    }

    if (!canNavigateForward) {
      if (zoomNextBtn.current) zoomNextBtn.current.classList.add("disabled");
    } else {
      if (zoomNextBtn.current) zoomNextBtn.current.classList.remove("disabled");
    }
  };


  const handleHomeClick = () => {
    if (contextMapView) {
      let Zoomlevel = null;
      if("Satellite Imagery" == contextMapView.map.basemap.title || "Imagery" == contextMapView.map.basemap.title
        || "صور الأقمار الصناعية" == contextMapView.map.basemap.title || "Topographic Map" === contextMapView.map.basemap.title
        || 'خريطة طوبوغرافية' === contextMapView.map.basemap.title 
      ){
        Zoomlevel = initialExtent.zoom;
      }
      else{
        Zoomlevel = 1;
      }
      contextMapView.goTo({
        center: initialExtent.center,
        zoom: Zoomlevel,
      });
    }
  };

  const handleNextLevelClick = () => {
    _nextExtent.current = true;
    _extentHistoryIndx.current++;
    if (_extentHistoryIndx.current > _extentHistory.current.length - 1) {
      _extentHistoryIndx.current = _extentHistory.current.length - 1;
    }
    contextMapView.goTo(_extentHistory.current[_extentHistoryIndx.current].currentExtent);
  };

  const handlePreviousLevelClick = () => {
    if (_extentHistory.current.length > 0 && _extentHistory.current[_extentHistoryIndx.current].preExtent) {
      _prevExtent.current = true;
      contextMapView.goTo(_extentHistory.current[_extentHistoryIndx.current].preExtent);
      _extentHistoryIndx.current--;
    }
  };

  const handlePanModeClick = () => {
    if (panmode) {
      contextMapView.surface.style.cursor = "pointer";
      setPanMode(false);
    } else {
      contextMapView.surface.style.cursor = "default";
      setPanMode(true);
    }
  };

  const handleCurrentLocatoin =()=>{
    //alert("Current Location Clicked !")
    // Create the Locate widget
    const locateWidget = new Locate({
      view: contextMapView, // Attach to your MapView
      graphic: new Graphic({
        symbol: {
          type: "simple-marker", // Circle marker
          style: "circle",
          color: "blue",
          size: "12px",
          outline: {
            color: "white",
            width: 2
          }
        }
      }),
      geolocationOptions: {
        enableHighAccuracy: true, // Try to use GPS for higher precision
        maximumAge: 0,            // Don't use cached location
        timeout: 10000             // Set timeout for locating
      }
    });

    // Trigger location finding
    locateWidget.locate().then(() => {
      console.log("Location found successfully!");
    }).catch((error) => {
      if (error.name === "GeolocationPositionError") {
        alert(
          "Cannot access your location. Please enable location permissions in your browser settings."
        );
      } else {
        console.error("Error finding location:", error);
      }
    });
  }


  return (
    <div
  className={`fixed ${
    isLangArab ? "right-2" : " sm:left-2 "
  } ml-3 laptop_s:top-1/2 sm:top-64  top-20 sm:mt-2 laptop_s:mt-0 laptop_s:-translate-y-1/2 z-10 ${isEditPOI?" hidden sm:flex":"flex"}  flex-col items-center space-y-2 bg-transparent p-2 rounded-full`}
>
<button
    onClick={handleBasemapMenuItemClick}
    data-tooltip-id="tooltip-0"
    data-tooltip-content={ isLangArab?"معرض الخريطة الأساسية":"Basemap Gallery"}
    className="w-12 h-12 sm:w-10 sm:h-10 text-white -translate-x-1 sm:translate-x-0 rounded-full flex  items-center justify-center transition-colors duration-200"
  >
    <img
      src={isDarkMode ? HomeDark : Home}
      alt="Home Icon"
      className="w-10 h-10 sm:w-8 sm:h-8"
    />
    <div className="absolute py-6 flex-1 justify-between">
      <img src={BookmarkWhite} alt="Home Sign" className="w-5 sm:w-4" />
    </div>
    <ReactTooltip
        id="tooltip-0"
        place="top"
        className="ToolTipBasemapEnvi z-30"
      />
  </button>
      <div
  className={`bg-transparent  sm:hidden flex rounded-full z-40  mobile_s:mr-2 tab:mr-0.5  laptop_m:mr-2 justify-center items-center cursor-pointer`} 
  onClick={()=>setIsGeneralInfo(!isGeneralInfo)}
      >
        {/* <img
          src={`${LocationupdatedLogo}`}
          alt=""
          className="w-[67%] translate-x-1 h-[67%]"
        /> */}
          <img
      src={isDarkMode ? HomeDark : Home}
      alt="Home Icon"
      className="w-10 h-10 sm:w-8 sm:h-8"
    />
    <div className="absolute right-5 py-6 flex-1 justify-between">
      <img src={LocationupdatedLogo} alt="Home Sign" className="" />
    </div>
      </div>
      <div
  className={`bg-transparent sm:hidden flex rounded-full z-40  mobile_s:mr-2 tab:mr-0.5  laptop_m:mr-2 justify-center items-center cursor-pointer`} 
  onClick={()=>setIsStockInfo(!isStackInfo)}
      >
        {/* <img
          src={`${StackLogo}`}
          alt=""
          className="w-[67%]  h-[67%]"
        /> */}
        <img
      src={isDarkMode ? HomeDark : Home}
      alt="Home Icon"
      className="w-10 h-10 sm:w-8 sm:h-8"
    />
    <div className="absolute py-6 flex-1 justify-between">
      <img src={StackLogo} alt="Home Sign" className="" />
    </div>
      </div>
  
  {/* <button
    onClick={handleBasemapMenuItemClick}
    data-tooltip-id="tooltip-0"
    data-tooltip-content={ isLangArab?"معرض الخريطة الأساسية":"Basemap Gallery"}
    className="w-12 h-12 sm:w-10 sm:h-10 text-white -translate-x-1 sm:translate-x-0 rounded-full flex  items-center justify-center transition-colors duration-200"
  >
    <img
      src={isDarkMode ? HomeDark : Home}
      alt="Home Icon"
      className="w-10 h-10 sm:w-8 sm:h-8"
    />
    <div className="absolute py-6 flex-1 justify-between">
      <img src={BookmarkWhite} alt="Home Sign" className="w-5 sm:w-4" />
    </div>
    <ReactTooltip
        id="tooltip-0"
        place="top"
        className="ToolTipBasemapEnvi z-30"
      />
  </button> */}
  {/* Home Button */}
  <button
    onClick={handleHomeClick}
    data-tooltip-id="tooltip-10"
    data-tooltip-content={ isLangArab?"الصفحة الرئيسية":"Default Extent"}
    className="w-12 h-12 sm:w-10 sm:h-10 text-white rounded-full sm:flex hidden items-center justify-center transition-colors duration-200"
  >
    <img
      src={isDarkMode ? HomeDark : Home}
      alt="Home Icon"
      className="w-10 h-10 sm:w-8 sm:h-8"
    />
    <div className="absolute py-6 flex-1 justify-between">
      <img src={HomeSign} alt="Home Sign" className="w-6 sm:w-5" />
    </div>
    <ReactTooltip
        id="tooltip-10"
        place="top"
        className="ToolTipBasemapEnvi z-30"
      />
  </button>

  {/* Plus Minus Section */}
  <div className="w-12 sm:w-10 text-white rounded-full sm:flex hidden flex-col items-center transition-colors duration-200">
    {/* Plus button (Zoom in) */}
    <button className="w-full h-8 sm:h-6 my-10 sm:my-8 flex items-center justify-center">
      <img
        src={isDarkMode ? plusMinusBgDark : plusMinusBg}
        alt="Plus Minus Background"
        className="relative w-10 sm:w-8"
      />
      <div className="absolute py-6 flex-1 justify-between">
       <button
          className={`-translate-y-5  sm:-translate-y-4 flex justify-center items-center`}
          onClick={() => (contextMapView.zoom += 1)}
          data-tooltip-id="tooltip-11"
          data-tooltip-content={ isLangArab?"تكبير":"Zoom in"}
        >
          <img src={IsMaxZoom ? PlusSign:DisablePlus} alt="Plus Sign" className={`${IsMinZoom?"w-6 sm:w-5":"w-6 sm:w-5"}`} />
          <ReactTooltip
        id="tooltip-11"
        place="top"
        className="ToolTipBasemapEnvi z-30"
      />
        </button>
        <img src={DashSign} alt="Dash Sign" className="w-6 sm:w-5 -translate-y-1" />
        <button
          className="translate-y-2 p-1 sm:p-1 flex justify-center items-center"
          onClick={() => (contextMapView.zoom -= 1)}
          data-tooltip-id="tooltip-12"
          data-tooltip-content={ isLangArab?"تصغير":"Zoom out"}
        >
          <img src={IsMinZoom?MinusSign:DisableMinus} alt="Minus Sign" className={` ${IsMinZoom?"w-4  sm:w-3":"w-4  sm:w-3"}`} />
          <ReactTooltip
        id="tooltip-12"
        place="top"
        className="ToolTipBasemapEnvi z-30"
      />
        </button>
      </div>
    </button>
  </div>

  {/* Hand Button */}
  <button
    onClick={handlePanModeClick}
    data-tooltip-id="tooltip-13"
    data-tooltip-content={ isLangArab?"التحريك":"Pan "}
    className="w-12 h-12 sm:w-10 sm:h-10 text-white rounded-full sm:flex hidden items-center justify-center transition-colors duration-200"
  >
    <img
      src={isDarkMode ? HomeDark : Home}
      alt="Hand Icon"
      className="w-10 h-10 sm:w-8 sm:h-8"
    />
    <div className="absolute py-6 flex-1 justify-between">
      <img src={Hand} alt="Hand Sign" className="w-4 sm:w-3.5 mr-1" />
    </div>
    <ReactTooltip
        id="tooltip-13"
        place="top"
        className="ToolTipBasemapEnvi z-30"
      />
  </button>

  {/* Left Arrow Button */}
  <button
    onClick={handlePreviousLevelClick}
    ref={zoomPrevBtn}
    data-tooltip-id="tooltip-14"
    data-tooltip-content={ isLangArab?" المدى السابق":"Previous Extent"}
    className="w-12 h-12 sm:w-10 sm:h-10 text-white rounded-full sm:flex hidden items-center justify-center transition-colors duration-200"
  >
    <img
      src={canGoBack? isDarkMode ? HomeDark : Home:DisableLeftHome}
      alt="Left Arrow Icon"
      className="w-10 h-10 sm:w-8 sm:h-8"
    />
     <div className="absolute py-6 flex-1 justify-between">
      {canGoBack && <img src={LeftArrow} alt="Left Arrow" className="w-3 sm:w-2.5 mr-1" />}
    </div>
    <ReactTooltip
        id="tooltip-14"
        place="top"
        className="ToolTipBasemapEnvi z-30"
      />
  </button>

  {/* Right Arrow Button */}
  <button
    onClick={handleNextLevelClick}
    ref={zoomNextBtn}
    data-tooltip-id="tooltip-15"
  data-tooltip-content={ isLangArab?"المدى التالي":"Next Extent"}
    className="w-12 h-12 sm:w-10 sm:h-10 text-white rounded-full sm:flex hidden items-center justify-center transition-colors duration-200"
  >
    <img
      src={canGoForward?isDarkMode ? HomeDark : Home:DisableRigthHome}
      alt="Right Arrow Icon"
      className="w-10 h-10 sm:w-8 sm:h-8"
    />
    <div className="absolute py-6 flex-1 justify-between">
     {canGoForward && <img src={RightArrow} alt="Right Arrow" className="w-3 sm:w-2.5" />}
    </div>
    <ReactTooltip
        id="tooltip-15"
        place="top"
        className="ToolTipBasemapEnvi z-30"
      />
  </button>
   {/* Current Location  Button */}


   <button id="findLocation"
    onClick={handleCurrentLocatoin}
    // ref={zoomNextBtn}
    data-tooltip-id="tooltip-15"
  data-tooltip-content={ isLangArab?"المدى التالي":"Current Location"}
    className="w-12 h-12 sm:w-10 sm:h-10 -translate-x-1 sm:translate-x-0 text-white rounded-full flex items-center justify-center transition-colors duration-200"
  >
    <img
      src={isDarkMode ? HomeDark : Home}
      alt="Right Arrow Icon"
      className="w-10 h-10 sm:w-8 sm:h-8"
    />
    <div className="absolute py-6 flex-1 justify-between">
     <img src={LigthLocationNavigation} alt="Right Arrow" className="w-5 sm:w-4" />
    </div>
    <ReactTooltip
        id="tooltip-15"
        place="top"
        className="ToolTipBasemapEnvi z-30"
      />
  </button> 

</div>
  );
}


